import { DxoUiTable } from './src/DxoUiTable.js';

export { DxoUiTable } from './src/DxoUiTable.js';

const ElementRegistered = window.customElements.get('dxo-ui-table');

if (!ElementRegistered) {
  window.customElements.define('dxo-ui-table', DxoUiTable as any);
}
